import { useMutation } from '@tanstack/react-query';
import { terminologyApi } from '../api/terminologyApi';
import type { ApiError, TerminologyDownloadResult, TerminologyExportParams } from '../types/terminology';

/**
 * Mutation: GET /api/eraf/terminology/export (enhance-biz #632)
 * 성공 시 blob+filename 을 반환 — 호출부가 브라우저 다운로드를 트리거한다.
 */
export function useTerminologyExport() {
  return useMutation<TerminologyDownloadResult, ApiError, TerminologyExportParams>({
    mutationFn: (params) => terminologyApi.exportTerminology(params),
    mutationKey: ['terminology-management', 'export'],
  });
}

/**
 * Mutation: GET /api/eraf/terminology/starter-pack (enhance-biz #632)
 */
export function useTerminologyStarterPack() {
  return useMutation<TerminologyDownloadResult, ApiError, void>({
    mutationFn: () => terminologyApi.downloadStarterPack(),
    mutationKey: ['terminology-management', 'starter-pack'],
  });
}
